export default __webpack_public_path__ + "static/media/dressed-table.1ad71f77.PNG";